module.exports = __webpack_public_path__ + "static/img/5.4eb54d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news19/5.png
// module id = ffhU
// module chunks = 1